import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function getAllFonction():Promise<Fonction[]>{
    const res:any = await dataFetcher(`fonctions`, {
        method:'get',
    })
    return res["hydra:member"];
}
